import adminDashboardSlice from './adminDashboardSlice'
export default adminDashboardSlice.reducer
